__turbopack_context__.v({
  "card": "SectionTitleCard-module__Md_sja__card",
  "wrapper": "SectionTitleCard-module__Md_sja__wrapper",
});
